import { render, staticRenderFns } from "./CustomerId.vue?vue&type=template&id=897f6328&scoped=true&"
import script from "./CustomerId.vue?vue&type=script&lang=js&"
export * from "./CustomerId.vue?vue&type=script&lang=js&"
import style0 from "./CustomerId.vue?vue&type=style&index=0&id=897f6328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897f6328",
  null
  
)

export default component.exports